module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jsnt-950412a5e988c55e7b955b7dae64d12c.svg";